import {
  FaFacebook,
  FaGithub,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { Icon } from "./appbar";

export default function SocialMedia({ cName, upperCname = "justify-evenly" }) {
  return (
    <div
      className={`flex md:flex-initial flex-1 items-center md:px-0 px-5 ${upperCname}`}
    >
      <a
        href="https://www.github.com/konson22/"
        target="_blank"
        rel="noreferrer"
        className="flex items-center"
      >
        <Icon icon={<FaGithub />} cName={cName} />
      </a>
      <a
        href="https://www.linkedin.com/in/kon-akech-10624b221/"
        target="_blank"
        rel="noreferrer"
        className="flex items-center"
      >
        <Icon icon={<FaLinkedinIn />} cName={cName} />
      </a>
      <a
        href="https://twitter.com/konsonak"
        target="_blank"
        rel="noreferrer"
        className="flex items-center"
      >
        <Icon icon={<FaTwitter />} cName={cName} />
      </a>
      <a
        href="https://facebook.com/koni.akech"
        target="_blank"
        rel="noreferrer"
        className="flex items-center"
      >
        <Icon icon={<FaFacebook />} cName={cName} />
      </a>
      <a
        href="https://www.instagram.com/konsonakech"
        target="_blank"
        rel="noreferrer"
        className="md:flex hidden items-center"
      >
        <Icon icon={<FaYoutube />} cName={cName} />
      </a>
      <a
        href="https://www.instagram.com/konsonakech"
        target="_blank"
        rel="noreferrer"
        className="flex items-center"
      >
        <Icon icon={<FaWhatsapp />} cName={cName} />
      </a>
    </div>
  );
}
